export default __webpack_public_path__ + "static/media/admin-pic.fa488c07.jpeg";